import request from "@/utils/request";
import { buildSmsSign } from '@/utils/sign';

export function login(query) {
    return request({
        url: '/basic/supplier/loginSupplier',
        method: 'post',
        headers: {
            isToken: false
        },
        params: query
    })
}

// 手机号验证码登录
export function loginByPhone(phone, smsCode) {
    return request({
        url: '/basic/supplier/loginByPhone',
        method: 'post',
        headers: {
            isToken: false
        },
        params: { phone, smsCode }
    })
}

// 手机号登录 - 选定供应商后登录
export function loginByPhoneSelect(phone, hid) {
    return request({
        url: '/basic/supplier/loginByPhoneSelect',
        method: 'post',
        headers: {
            isToken: false
        },
        params: { phone, hid }
    })
}

// 发送登录短信验证码
export function sendLoginSmsCode(phone) {
    const sign = buildSmsSign(phone);
    return request({
        url: '/basic/supplier/sendLoginSmsCode',
        method: 'get',
        headers: {
            isToken: false
        },
        params: { phone, ...sign }
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captchaImage',
        method: 'get',
        headers: {
            isToken: false
        },
        timeout: 20000
    })
}

export function logout() {
    return request({
        url: '/basic/supplier/logout',
        method: 'post',
    })
}